module.exports = __webpack_public_path__ + "img/01_EN.1a2a6d02.jpg";